// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowDownLightSmall: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 9 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M4.922 9.148c-.234.211-.586.211-.797 0l-3.75-3.75a.54.54 0 010-.796c.21-.211.563-.211.773 0L4.5 7.953l3.352-3.351c.234-.211.585-.211.796 0 .235.234.235.585 0 .796l-3.75 3.75h.024z" />
        </svg>
    );
};

export default React.memo(IconArrowDownLightSmall);
